import type React from 'react';
import { format } from 'date-fns';

import { DateInput, DatePicker, FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { FIRE_ESCAPE } from '../../../constants';
import YesAndNoExpansion from '../../../../shared/components/Widgets/YesAndNoExpansion';
import { DATE_PICKER_FORMAT } from '../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function FireEscape({ section, setSectionValues }: Props) {
  function onNoFireEscape(): void {
    setSectionValues({ [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE]: false });
  }

  function onYesFireEscape(): void {
    setSectionValues({ [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE]: true });
  }

  function setFireEscapeLocationDescription(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_LOCATION]: event.currentTarget.value,
    });
  }

  function onFireEscapeServiceDateChange(formattedDate: string): void {
    setSectionValues({
      [FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_SERVICE_DATE]: formattedDate,
    });
  }

  return (
    <FormField
      required
      label={<Label>Are there fire escapes on the tenant’s floor?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesFireEscape}
          noHandler={onNoFireEscape}
          yesActive={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE)}
        >
          <FormField
            required
            css={{ marginTop: 'layout.tight', marginBottom: 'layout.tight' }}
            label={<Label>Describe the location of the fire escapes on the tenant’s floor</Label>}
            control={
              <Textarea
                css={{ resize: 'vertical' }}
                onChange={setFireEscapeLocationDescription}
                value={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_LOCATION)}
              />
            }
          />
          <FormField
            required
            label={<Label>Fire escape service date</Label>}
            control={
              <DatePicker
                dateFormat={DATE_PICKER_FORMAT}
                value={section.getFieldValue(FIRE_ESCAPE.FIELD_NAME.FIRE_ESCAPE_SERVICE_DATE)}
                onValueChange={(value) => {
                  const formatted = typeof value === 'string' ? value : format(value, DATE_PICKER_FORMAT);
                  onFireEscapeServiceDateChange(formatted);
                }}
                maxDate={new Date()}
                closeModalOnDateSelect
                input={<DateInput />}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

FireEscape.description = 'Asks about fire escape features within a building';

export default FireEscape;
